namespace TabAurous.Inventory {
    export interface MaterialRequestRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        CompanyName?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        BaseItemTypeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        Username?: string;
        ItemDetails?: MaterialRequestItemsRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
    }

    export namespace MaterialRequestRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.MaterialRequest';
        export const deletePermission = 'Inventory:MaterialRequest:Delete';
        export const insertPermission = 'Inventory:MaterialRequest:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:MaterialRequest:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            CompanyName = "CompanyName",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            BaseItemTypeId = "BaseItemTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            Username = "Username",
            ItemDetails = "ItemDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount"
        }
    }
}
